var MusicLibrary = /** @class */ (function () {
    function MusicLibrary(libraryJson) {
        if (!libraryJson.groups || libraryJson.groups.length === 0) {
            throw new Error("Invalid library JSON: ".concat(libraryJson));
        }
        this.groups = libraryJson.groups;
        this.allowedSounds = null;
    }
    MusicLibrary.prototype.getLengthForId = function (id) {
        var _a;
        return ((_a = this.getSoundForId(id)) === null || _a === void 0 ? void 0 : _a.length) || null;
    };
    MusicLibrary.prototype.getSoundForId = function (id) {
        var splitId = id.split('/');
        var path = splitId[0];
        var src = splitId[1];
        var folder = this.getFolderForPath(path);
        if (folder) {
            return folder.sounds.find(function (sound) { return sound.src === src; }) || null;
        }
        return null;
    };
    MusicLibrary.prototype.getFolderForPath = function (path) {
        return this.groups[0].folders.find(function (folder) { return folder.path === path; }) || null;
    };
    // A progression step might specify a smaller set of allowed sounds.
    MusicLibrary.prototype.setAllowedSounds = function (allowedSounds) {
        this.allowedSounds = allowedSounds;
    };
    // A sound picker might want to show the subset of sounds permitted by the
    // progression's currently allowed sounds.
    MusicLibrary.prototype.getAllowedSounds = function (folderType) {
        var _this = this;
        var folders = this.groups[0].folders;
        // Let's just do a deep copy and then do filtering in-place.
        var foldersCopy = JSON.parse(JSON.stringify(folders));
        // Whether or not we have allowedSounds, we need to filter by type.
        foldersCopy = foldersCopy.filter(function (folder) { return folder.type === folderType; });
        if (this.allowedSounds) {
            foldersCopy = foldersCopy.filter(function (folder) { var _a; return (_a = _this.allowedSounds) === null || _a === void 0 ? void 0 : _a[folder.path]; });
            foldersCopy.forEach(function (folder) {
                folder.sounds = folder.sounds.filter(function (sound) { var _a, _b; return (_b = (_a = _this.allowedSounds) === null || _a === void 0 ? void 0 : _a[folder.path]) === null || _b === void 0 ? void 0 : _b.includes(sound.src); });
            });
        }
        return foldersCopy;
    };
    return MusicLibrary;
}());
export default MusicLibrary;
